var React = require('react');

function IconPreviousInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Expertise","transform":"translate(-1544.000000, -27.000000)","stroke":"#000000","strokeWidth":"2"},React.createElement("g",{"id":"Group-7","transform":"translate(1546.000000, 29.000000)"},[React.createElement("path",{"d":"M0,5.9765 L6.439,12.4165","id":"Stroke-1","strokeLinecap":"square","key":0}),React.createElement("path",{"d":"M0,24.9765 L9.5,24.9765 C14.747,24.9765 19,20.7235 19,15.4765 C19,10.2295 14.747,5.9765 9.5,5.9765 L0,5.9765","id":"Stroke-3","key":1}),React.createElement("path",{"d":"M0,5.9765 L5.977,-0.0005","id":"Stroke-5","strokeLinecap":"square","key":2})]))));
}

IconPreviousInline.defaultProps = {"width":"22px","height":"28px","viewBox":"0 0 22 28","version":"1.1"};

module.exports = IconPreviousInline;

IconPreviousInline.default = IconPreviousInline;
